// The ledger recorded this module as app-side on one ground: it read
// `getDomains()`. That read is the `resolveApiOrigin` port now; the
// trailing-slash strip stays here, where it was.
//
// HISTORY POINTER. `git log --follow` does NOT reach past the move for this file
// at git's default 50% similarity: the port rewrite replaced most of a small
// module, so the rename scores below the threshold. Either of these works:
//
//   git log --follow -M20% -- src/features/agent-harness/url.ts
//   git log -- src/features/agent-harness/url.ts
import { getAgentsDataConfig } from '../../data/config';

export const agentHarnessUrl = (path: string): string =>
  `${getAgentsDataConfig().resolveApiOrigin().replace(/\/+$/, '')}${path}`;
